import axios from 'axios';
import * as endpoint from '../../../endpoint';
import * as actionTypes from '../../../actionTypes';
import {
  checkCancelToken,
  consolelog,
  delCancelToken,
} from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';
import { REPORT_UPDATE_ERROR_CODE } from '../../../../lib/constants';

/**
 * 報告書情報を更新する。
 *
 * @param {string} apiToken - APIトークン
 * @param {Object} apiParams - APIパラメータ
 * @param {string} groupId - グループID。
 * @param {string} reportId - 報告書ID。
 * @returns
 */
const updateReport =
  (apiToken, apiParams, groupId, reportId, lastModifiedDate, afterAction) =>
  async dispatch => {
    consolelog('[API CALL] updateReport()', apiToken);
    configureAxiosForJSON(apiToken);
    const { cancelToken, cancelTokenKey } = createCancelToken('updateReport');
    const url = endpoint.API_UPDATE_REPORT.replace(
      '{groupId}',
      groupId,
    ).replace('{reportId}', reportId);

    const params = {
      ...apiParams,
    };

    const axiosConfig = {
      headers: {
        'If-Unmodified-Since': lastModifiedDate,
      },
      cancelToken,
    };

    try {
      const res = await axios.patch(url, params, axiosConfig);
      if (checkCancelToken(cancelTokenKey)) {
        dispatch({ type: actionTypes.SET_REFRESH_PAGE_TRUE });
        if (afterAction) {
          dispatch({ type: afterAction, payload: res.data });
        }
      }
      delCancelToken(cancelTokenKey);
      return res;
    } catch (thrown) {
      if (!axios.isCancel(thrown)) {
        if (
          thrown.response.status === 412 ||
          thrown.response?.data?.errorCode ===
            REPORT_UPDATE_ERROR_CODE.UNEDITABLE_CONTENT
        ) {
          return thrown;
        }
        handleErrorResponse(
          thrown,
          dispatch,
          '',
          '報告書を更新できませんでした。',
        );
      }
      delCancelToken(cancelToken);
      return thrown;
    }
  };

export default updateReport;
